import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { vissue } from '@/api/vissue'
import article from '@/api/article'
import help from '@/utils/help'
const columns = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code'
  },
  {
    title: '',
    enTitle: 'DOI',
    width: 220,
    dataIndex: 'doi'
  },
  {
    title: '',
    enTitle: 'Title',
    width: 400,
    dataIndex: 'titleText',
    slot: 'omis'
  },
  // {
  //   title: '',
  //   enTitle: 'Assigned Editor',
  //   width: 120,
  //   dataIndex: 'readNum',
  //   slot: 'readNum'
  // },
  {
    title: '',
    enTitle: 'Submission Time',
    width: 170,
    dataIndex: 'submittedDate',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'status',
    slot: 'publish'
  },
  {
    title: '',
    enTitle: 'Published Time',
    width: 150,
    dataIndex: 'publishedDate',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Updated Time',
    width: 150,
    dataIndex: 'updateTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 120,
    dataIndex: 'operator',
    slot: 'operator'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 190,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: { SiteSearchGroup },
  data() {
    return {
      columns,
      id: '',
      params: {},
      dataSource: [],
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      vol: '',
      issue: ''
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain'
    })
  },
  async mounted() {
    this.id = this.$route.params.id
    this.vol = this.$route.query.vol
    this.issue = this.$route.query.issue
    await this.getList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await vissue.getArticle(
        this.id,
        data
      )
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    handleClear() {
      this.params.keyword = ''
      this.getList()
    },
    edit(val) {
      this.$router.push(`/publishing/publication/${val.id}`)
    },
    xmlExp() {},
    async exp() {
      const res = await vissue.export(this.id, this.params)
      help.download(res.url, res.fileName)
    },
    async able(val, status) {
      const { id, version } = val
      await article.changeStatus([
        {
          id,
          status,
          version
        }
      ])
      let content = `This Article has been ${status.toLowerCase()}!`
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    }
  }
}
